<template>
  <div class="container">
    <div class="search_box">
      <el-form ref="form" class="search_form" :model="tableParams" label-position="left">
        <el-form-item label="搜索内容" label-width="70px">
          <el-input v-model="tableParams.searchParam" placeholder="请输入名称/联系人/电话" clearable></el-input>
        </el-form-item>

        <el-form-item label="工单状态" label-width="70px">
          <el-select v-model="solveStatus" placeholder="请选择工单状态" clearable>
            <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工单日期" label-width="70px">
          <el-date-picker v-model="timeList" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="timeChange">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" class="search_area_btn" @click="onSubmit">搜索</el-button>
          <el-button icon="el-icon-upload2" class="search_area_btn" @click="downloadExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table_box">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="未处理" name="1"></el-tab-pane>
        <el-tab-pane label="已处理" name="2"></el-tab-pane>
      </el-tabs> -->
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <!--  :height="tableHeight" -->
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="content" label="反馈内容" width="200"> </el-table-column>
        <el-table-column property="contactsName" label="联系人" width="120">
        </el-table-column>
        <el-table-column property="contactsPhone" label="联系方式" width="120">
        </el-table-column>
        <el-table-column property="contactsEmail" label="联系邮箱" width="120">
        </el-table-column>

        <el-table-column property="orderTypeDesc" label="工单类型" width="180">
        </el-table-column>
        <el-table-column property="addr" label="区域地址" width="200"> </el-table-column>
        <el-table-column property="addrDetail" label="详细地址" width="360">
        </el-table-column>
        <el-table-column property="addrDetail" label="反馈图片" width="140" align="center">
          <template slot-scope="scope">
            <div v-for="(i, idx) in scope.row.picList" :key="idx">
              <el-image style="width: 120px;" :src="i" :preview-src-list="scope.row.picList" v-if="i">
              </el-image>
              <div v-else>暂无图片</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="solveStatusDesc" label="处理状态" width="120">
        </el-table-column>
        <el-table-column property="solveUser" label="处理人" width="120"> </el-table-column>
        <el-table-column property="solveRemark" label="备注" width="240"> </el-table-column>
        <el-table-column property="createTime" label="创建时间" width="160">
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goAssign(scope.row)"
              v-if="(scope.row.solveStatus == 0 || scope.row.solveStatus == 2) && !scope.row.solveUser">指派</el-button>
            <el-button type="text" @click="goDispose(scope.row)"
              v-if="(scope.row.solveStatus == 1 || scope.row.solveStatus == 3) && scope.row.solveUser == userInfo.userId">处理</el-button>
            <el-button type="text" @click="goConfirmOrder(scope.row)"
              v-if="(scope.row.solveStatus == 0 || scope.row.solveStatus == 2) && scope.row.solveUser == userInfo.userId">确认</el-button>
            <el-button type="text" @click="goAddWorkOrder(scope.row)"
              v-if="scope.row.solveStatus == 3 || scope.row.solveStatus == 4">转工单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="paging_box">
        <!--  :current-page="currentPage4" -->
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <v-confirmOrder :show.sync="confirmOrderShow" :data="confirmOrderData"></v-confirmOrder>
    <v-assign :show.sync="assignShow" :data="assignData"></v-assign>
    <v-dispose :show.sync="disposeShow" :data="disposeData"></v-dispose>
    <v-add :show.sync="addShow" :data="addData"></v-add>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util.js";
import assign from "./component/assign.vue";
import confirmOrder from "./component/confirmOrder.vue";
import dispose from './component/dispose.vue';
import add from "./component/add.vue";
import config from '@/utils/config';
export default {
  name: "",
  data () {
    return {
      tableData: [],
      tableParams: {
        page: 1,
        limit: 10,
        searchParam: "",
        startTime: "",
        endTime: "",
        // solveStatus: 0, // 处理状态  未处理 0   已确认 1  被驳回 2   处理中 3   已处理 4
      },
      solveStatus: null,
      total: 0,
      tableLoading: false,
      stateList: [{
        value: 0,
        label: '未处理'
      }, {
        value: 1,
        label: '已确认'
      }, {
        value: 2,
        label: '被驳回'
      }, {
        value: 3,
        label: '未处理(处理中)'
      }, {
        value: 4,
        label: '已处理'
      },],
      timeList: [],
      assignShow: false,
      assignData: {},
      confirmOrderShow: false,
      confirmOrderData: {},
      disposeShow: false,
      addShow: false,
      addData: {},
      disposeData: {},
      userInfo: "",
      // tableHeight: 'calc(100vh - 394px)'
    };
  },
  components: {
    "v-confirmOrder": confirmOrder,
    "v-assign": assign,
    "v-dispose": dispose,
    "v-add": add
  },
  props: {},
  created () {
    this.getList();
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  },
  methods: {
    getList () {
      this.$http.queryAdviceList(this.tableParams).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit () {
      this.tableParams.solveStatus = this.solveStatus;
      this.getList();
    },
    downloadExport() {
      var data=this.tableParams;
      var url=config.baseUrl+'/advice/exportExcel?Authorization='+sessionStorage.getItem("Token");
      if(data.searchParam){
        url+='&searchParam='+data.searchParam;
      }
      // if(data.solveStatus){
      //   url+='&solveStatus='+data.solveStatus;
      // }
      if(data.startTime){
        url+='&startTime='+data.startTime;
      }
      if(data.endTime){
        url+='&endTime='+data.endTime;
      }
      window.open(url, '_blank');
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    goAssign (row) {
      this.assignShow = true;
      this.assignData = row;
    },
    goDispose (row) {
      this.disposeShow = true;
      this.disposeData = row;
    },
    goConfirmOrder (row) {
      this.confirmOrderShow = true;
      this.confirmOrderData = row;
    },
    goAddWorkOrder (row) {
      this.addShow = true;
      this.addData = row;
    },
    timeChange (e) {
      if (e == null) {
        this.tableParams.startTime = "";
        this.tableParams.endTime = "";
      } else {
        this.tableParams.startTime = dateTransition(e[0]);
        this.tableParams.endTime = dateTransition(e[1]);
      }
    },
    handleClick (e) {
      if (e.index == '0') {
        this.tableParams.solveStatus = 0
        this.getList();
      } else if (e.index == '1') {
        this.tableParams.solveStatus = 4
        this.getList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/feedback/feedback.vue